import { Result } from '@cplug/frontend-core/utils'
import { BaseGatewayErrorDTO } from '@cplug/frontend-core/gateways'
import { isSuccessResponse, ErrorCodes, type BaseError } from '@cplug/frontend-core/models'
import type { UserSession } from '../models/UserSession'
import { mapDTOToUserSession, mapUserSessionToDTO, UserSessionDTO } from './DTOs/UserSessionDTO'
import { CPBaseCRUDGateway } from '~/shared/gateways/CPBaseCRUDGateway'

type ListDTO = { sessions: UserSessionDTO[] }

export class CPUserSessionGateway extends CPBaseCRUDGateway<UserSessionDTO, ListDTO, UserSession> {
  protected apiUrlDomain = 'users/sessions'

  protected dtoToModelMapper = (dto: UserSessionDTO): Result<UserSession> => Result.ofValue(mapDTOToUserSession(dto))
  protected modelToDtoMapper = mapUserSessionToDTO
  protected dtoSchema = UserSessionDTO

  protected get listField (): 'sessions' {
    return 'sessions'
  }

  protected override get modelIdField (): keyof UserSession {
    return 'id'
  }

  async revokeSession (sessionId: string): Promise<Result<void>> {
    const response = await this.put(`${this.apiUrlDomain}/${sessionId}`)
    if (response === null || !isSuccessResponse(response)) {
      return Result.ofError(new BaseGatewayErrorDTO().deserialize(response?.data) ?? <BaseError>{ code: ErrorCodes.Unknown })
    }

    return Result.ofValue(undefined)
  }
}
